<template>
    <div>
        <div class="px-6">
            <p class="text-medium-grey font-bold text-xl mb-3">{{ title }}</p>
        </div>
        <div class="grid grid-cols-1 lg:grid-cols-4 gap-4 mb-4">
            <UserProductieMonthlyStats :user-id="userId" :user-role="userRole" :month-first-day="monthFirstDay" />
            <UserProductieAnnualStats :user-id="userId" :year-first-day="yearFirstDay" />
            <UserProductieConfiguratorCalledStats :user-id="userId" :user-zone="userZone"
                :month-first-day="monthFirstDay" />
            <TeamProductieMonthlyStats :month-first-day="monthFirstDay" />
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import UserProductieMonthlyStats from '@/components/Dashboard/UserProductieMonthlyStats.vue';
import UserProductieAnnualStats from '@/components/Dashboard/UserProductieAnnualStats.vue';
import UserProductieConfiguratorCalledStats from '@/components/Dashboard/UserProductieConfiguratorCalledStats.vue';
import TeamProductieMonthlyStats from '@/components/Dashboard/TeamProductieMonthlyStats.vue';

export default {
    name: 'AgentObjectivesProgress',
    components: {
        UserProductieMonthlyStats,
        UserProductieAnnualStats,
        UserProductieConfiguratorCalledStats,
        TeamProductieMonthlyStats,
    },
    props: {
        title: { type: String, default: 'Obiective' },
        userId: { type: Number, required: true },
        userZone: { type: String, default: '' },
        userRole: { type: String, default: '' },
        dateRange: { type: Array, required: true },
    },
    computed: {
        monthFirstDay() {
            const d = new Date(this.dateRange[0]);
            return new Date(d.getFullYear(), d.getMonth(), 2).toISOString().split('T')[0];
        },
        monthLastDay() {
            const d = new Date(this.dateRange[0]);
            return new Date(d.getFullYear(), d.getMonth() + 1, 1).toISOString().split('T')[0];
        },
        yearFirstDay() {
            const d = new Date(this.dateRange[0]);
            return new Date(d.getFullYear(), 0, 2).toISOString().split('T')[0];
        },
        yearLastDay() {
            const d = new Date(this.dateRange[0]);
            return new Date(d.getFullYear(), 12, 1).toISOString().split('T')[0];
        },
    },
    watch: {
        dateRange(newVal, oldVal) {
            if (newVal[0] !== oldVal[0] || newVal[1] !== oldVal[1]) {
                this.fetchAggregates();
            }
        },
        userId(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.fetchAggregates();
            }
        },
    },
    methods: {
        ...mapActions('userss', ['fetchUsersAggregates', 'fetchUsersConfiguratorCalledAggregates']),
        fetchAggregates() {
            this.fetchUsersAggregates({ interval: 'monthly', department: 'productie', date1: this.monthFirstDay, date2: this.monthLastDay });
            this.fetchUsersAggregates({ interval: 'annual', department: 'productie', date1: this.yearFirstDay, date2: this.yearLastDay });
            this.fetchUsersConfiguratorCalledAggregates({ date1: this.monthFirstDay, date2: this.monthLastDay });
        },
    },
    created() {
        this.fetchAggregates();
    },
}
</script>
